import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
    continueWatchingActiveSelector,
    continueWatchingItemsSelector,
} from '../../../../../reducers/continueWatching';
import EndScreenWithContinueWatching from './EndScreenWithContinueWatching.jsx';
import ContentoQuery from '../../../../Contento/ContentoQuery';
import EndScreenQuery from '../../../EndScreenQuery.graphql';
import env from '../../../../../env';
import { generateListTracking } from '../../../../../utils/contentoUtils';

const EndScreenWithContinueWatchingContainer = ({
    escenicId,
    continueWatchingIsActive,
    continueWatchingItems,
}) => {
    const history =
        continueWatchingIsActive &&
        continueWatchingItems
            .toJS()
            .filter((item) => !item.deleted)
            .slice(0, 40) // Temp not using env.HISTORY_UPPER_LIMIT because of GET query length limitations in Apollo
            .map((continueWatchingItem) => ({
                id: continueWatchingItem.videoId,
                progressSeconds: parseInt(continueWatchingItem.position, 10) || 0,
            }));

    return (
        <ContentoQuery
            query={EndScreenQuery}
            variables={{
                history: history || [],
                includeFullOppetArkiv: env.FLAG_ENABLE_ALL_OA,
                id: escenicId,
            }}
            fetchPolicy="cache-first"
            ssr={false}
        >
            {(data) => {
                const recommendedItems = data.endScreenRecommendations.items;

                const listTracking = generateListTracking(data.endScreenRecommendations);

                return (
                    <EndScreenWithContinueWatching
                        recommendedItems={recommendedItems}
                        listTracking={listTracking}
                    />
                );
            }}
        </ContentoQuery>
    );
};

EndScreenWithContinueWatchingContainer.propTypes = {
    escenicId: PropTypes.string,
    accessService: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        continueWatchingIsActive: continueWatchingActiveSelector(state),
        continueWatchingItems: continueWatchingItemsSelector(state),
    };
};

export default connect(mapStateToProps)(EndScreenWithContinueWatchingContainer);
